<template>
  <introduce-page>
    <div style="width: 100%;">
      <div v-for="(detail, i) in dataList" :key="i" style="width: 100%;display: flex;margin-bottom: 20px;min-height: 160px;">
        <el-row style="width: 130px;height: 160px;">
          <div style="height: 100px;width: 100px;border-radius: 50px;border: 1px solid gray;">
            <el-image :src="getImageUrl(detail.avatar)" style="height: 100%;width: 100%;border-radius: 50px;"></el-image>
          </div>
          <div style="width: 100px;text-align: center;margin-top: 10px;">{{detail.name}}</div>
        </el-row>
        <div style="width: calc(100% - 130px);height: 100%;">
          <div style="line-height: 30px;white-space: pre-wrap;text-align: justify;text-indent: 2em;">{{detail.content}}</div>
        </div>
      </div>
    </div>
  </introduce-page>
</template>

<script>
import axios from 'axios'
import IntroducePage from './IntroducePage'
export default {
  name: 'CoreTeam',
  components: {IntroducePage},
  data() {
    return {
      dataList: [
        {avatar: 'bf1d2d8e8d9146eb8f81dfb018de2053', name: '张文魁', 'content': '公司创始人CEO，华中科技大学电气工程专业博士，副教授，湖北省碳达峰碳中和标准化技术委员会委员，湖北省科技厅科技专家库评审专家，光谷智慧能源产业创新标准联盟专家委员会专家委员，武昌博士创新联盟双碳专委会秘书长。拥有20多年能源行业从业经验，先后在中国华电、中国科学院软件所、中船重工709研究所、中国电子武汉中原电子从事发电、智慧城市、智慧园区、配电自动化及智慧能源等领域的研发和技术管理工作，担任技术总监。获得湖北省科技进步奖1项、中国电子科技进步奖1项、中国电子科技人才奖1项，发表SCI、EI论文十多篇，获得授权专利10多项，其中发明专利5项。'},
        {avatar: '10ed442bcfd747e1b790e422dc4af4a3', name: '刘沛', 'content': '公司首席顾问，华中科技大学教授，博士生导师。电力系统继电保护知名专家，中国水力发电工程学会水电自动化与计算机控制工程专委会委员，中国电机工程学会分专业委员会委员。多次获得省部级科技进步奖，主持过国家自然科学基金项目4项，培养博士10多名，硕士几十名。'},
        {avatar: '95a22da3eb1d4c15a585bee704de0703', name: '崔晓彦', 'content': '联合创始人，武汉理工大学艺术专业博士，国内著名漫画家、插画师，从事工业及美术设计领域研究，受邀在武汉琴台大剧院、丰子恺画院、武汉大学万林艺术博物馆等举办画展，漫画作品——《平安顺遂、遇难成祥》、《平平安安》被国家博物馆收藏，负责公司产品工艺设计及UI设计。'},
        {avatar: '1b848f69a9c24c1db711f3ae884c876e', name: '张宏超', 'content': '联合创始人，湖北大学微电子硕士。担任营销总监，在大型国企和软件公司从事多年研发管理和产品经理工作，有多年智慧城市、智慧能源领域工作经验。'},
        {avatar: '43f41e6197af435b896d5ddd9017242a', name: '洪满', 'content': '联合创始人，哈尔滨工业大学计算机专业学士。担任研发经理，拥有大型游戏公司和国企多年研发经验，精通Java、C++、MATLAB、Python、大数据分析等，主持过智慧路灯、配电自动化、智慧园区、综合能源服务平台等多个大型项目。'}
      ]
    }
  },
  created() {
    document.documentElement.scrollTop = 0
  },
  methods: {
    getImageUrl(id) {
      return '/myApi/coreTeam/getImageById?id=' + id
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/introduce/CoreTeam.vue